var map = {
	"./barbarian.png": 3265,
	"./bard.png": 5438,
	"./cleric.png": 835,
	"./druid.png": 5999,
	"./fighter.png": 8716,
	"./monk.png": 1910,
	"./paladin.png": 5098,
	"./ranger.png": 408,
	"./rogue.png": 1745,
	"./sorcerer.png": 1464,
	"./warlock.png": 6136,
	"./wizard.png": 5570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4967;